// extracted by mini-css-extract-plugin
export var container = "_dn-0";
export var popoverContent = "_dn-1";
export var tosLink = "_dn-2";